if (!customElements.get('cart-items')) {
  customElements.define(
    'cart-items',
    class CartItems extends HTMLElement {
      constructor() {
        super();
        this.decreaseButtons = this.querySelectorAll('[data-decrease-quantity]');
        this.increaseButtons = this.querySelectorAll('[data-increase-quanity]');
        this.quantityInputs = this.querySelectorAll('[data-quantity-input]');
        this.removeButtons = this.querySelectorAll('[data-remove-item]');
      }

      get sectionsToUpdate() {
        let sections = 'cart-icon-bubble,cart-drawer';
        if (window.location.href.includes('/cart')) {
          sections = 'cart-icon-bubble,main-cart-extend';
        }

        return sections;
      }

      connectedCallback() {
        this.setEventListeners();
        this.quantityInputs.forEach((input) => input.addEventListener('change', (event) => this.onQuantityChange(event)));
      }

      setEventListeners() {
        this.increaseQuantity();
        this.decreaseQuantity();
        this.removeItem();
      }

      increaseQuantity() {
        if (this.increaseButtons.length === 0) return;
        this.increaseButtons.forEach((button) => button.addEventListener('click', (event) => this.setQuantity(event)));
      }

      decreaseQuantity() {
        if (this.decreaseButtons.length === 0) return;
        this.decreaseButtons.forEach((button) => button.addEventListener('click', (event) => this.setQuantity(event)));
      }

      removeItem() {
        if (this.removeButtons.length === 0) return;
        this.removeButtons.forEach((button) => button.addEventListener('click', (event) => this.setQuantity(event)));
      }

      async onQuantityChange(event) {
        const lineItem = this.querySelector(`[data-cart-item-key="${event.target.dataset.key}"]`);
        lineItem.classList.add('opacity-50', 'cursor-progress');
        const url = `${window.Shopify.routes.root}cart/update.js`;
        const data = {
          updates: {
            [event.target.dataset.key]: event.target.value,
          },
          sections: this.sectionsToUpdate,
          sections_url: window.location.pathname,
        };

        const request = {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Access-Control-Allow-Origin': 'no-cors',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        };

        Promise.resolve().finally(async () => {
          const res = await this.fetchWithRetry(url, request);
          const result = await res.json();
          res.ok ? this.onSuccess(lineItem, result) : this.onError(event, lineItem, result.message);
        });
      }

      onSuccess(lineItem, result) {
        const afterChangeEvent = new CustomEvent('switch:cart:cartqtychange', {
          bubbles: true,
          detail: { response: result },
        });
        document.dispatchEvent(afterChangeEvent);
        lineItem.classList.remove('opacity-50', 'cursor-progress');
      }

      onError(event, lineItem, error) {
        const errorEl = lineItem.querySelector('[data-cart-quantity-error]');
        errorEl.textContent = error;
        errorEl.classList.remove('hidden');
        lineItem.classList.remove('opacity-50', 'cursor-progress');
        event.target.value = event.target.dataset.lastValue;
      }

      setQuantity(event) {
        event.preventDefault();
        const key = event.target.dataset.key;
        let selector = `input[data-key="${key}"]`;
        if (event.target.hasAttribute('cart-desktop-quantity')) {
          selector += '[cart-desktop-quantity]';
        }
        const quantityInput = this.querySelector(selector);
        if (!quantityInput) return;
        quantityInput.value = event?.target?.dataset?.value;
        setTimeout(() => {
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      async fetchWithRetry(url, init, retries = 2) {
        for (let i = 0; i <= retries; i++) {
          const res = await fetch(url, init);
          if (res.status !== 409) return res;
          await new Promise((r) => setTimeout(r, 150 * (i + 1)));
        }
        throw new Error('Cart busy after retries');
      }
    }
  );
}
